import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { authBackendEndPointToken } from '../app.config';

export interface ShareInvoiceBody {
  recipientFhirId?: string;
  recipientEmail?: string;
  note?: string;
}

export interface ShareInvoiceResult {
  message: string;
  inApp: boolean;
  emailSent: boolean;
}

@Injectable({ providedIn: 'root' })
export class InvoiceShareService {
  private http = inject(HttpClient);
  private authApiUrl = inject(authBackendEndPointToken);

  share(invoiceId: string, body: ShareInvoiceBody) {
    return this.http.post<ShareInvoiceResult>(
      `${this.authApiUrl}/api/invoices/${encodeURIComponent(invoiceId)}/share`,
      body
    );
  }
}
